export default __webpack_public_path__ + "static/promo-dont-have-card-yet-de39235799fbe6a5bb4eaf8fe8ff532f.webp";